// src/components/DynamicProductMenu.js
import React, { useState, useEffect } from 'react';
import { Button, Popover, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import axiosInstance from '../services/api';

const DynamicProductMenu = () => {
  const [productTypes, setProductTypes] = useState([]);
  const [productSubTypes, setProductSubTypes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    axiosInstance.get('/producttypes').then(r => setProductTypes(r.data)).catch(() => {});
    axiosInstance.get('/productsubtypes').then(r => setProductSubTypes(r.data)).catch(() => {});
  }, []);

  const close = () => setAnchorEl(null);
  const subsOf = (typeId) => productSubTypes.filter(st => st.productTypeId === typeId);

  return (
    <>
      <Button
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        sx={{
          color: 'white', mx: 1, px: 2, textTransform: 'none',
          fontWeight: 600, fontSize: '0.95rem', fontFamily: 'inherit',
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' },
        }}
      >
        Ürünler
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            mt: 1, p: 2.5, borderRadius: 2, boxShadow: 4,
            width: { xs: '92vw', md: 820 }, maxWidth: '95vw',
            maxHeight: '72vh', overflowY: 'auto',
          },
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
            columnGap: 3, rowGap: 2.5,
          }}
        >
          {productTypes.map((pt) => (
            <Box key={pt.id}>
              <Typography
                component={Link}
                to={`/products?type=${pt.id}`}
                onClick={close}
                sx={{
                  display: 'block', fontWeight: 700, color: 'primary.main',
                  textDecoration: 'none', mb: 0.75, fontSize: '0.95rem',
                  borderBottom: '2px solid', borderColor: 'primary.light', pb: 0.5,
                  '&:hover': { color: 'primary.dark' },
                }}
              >
                {pt.name}
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                {subsOf(pt.id).map((st) => (
                  <Typography
                    key={st.id}
                    component={Link}
                    to={`/products?subtype=${st.id}`}
                    onClick={close}
                    variant="body2"
                    sx={{
                      color: 'text.secondary', textDecoration: 'none', py: 0.25,
                      '&:hover': { color: 'primary.main' },
                    }}
                  >
                    {st.name}
                  </Typography>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default DynamicProductMenu;
